import React, { useEffect, useState } from 'react'
import { PageSection, Spinner, Title } from '@patternfly/react-core'
import { Button } from 'design-react-kit'

import { generateRequestFilter, generateRequestSort } from 'src/app/utils/ApiUtils'
import { GenericAsyncTableData, RequestData } from 'src/backoffice/app/components/GenericAsyncTableData'
import { PATH_TO_BO_CREA_PROROGA, PATH_TO_BO_LISTA_ISCRITTI_ORDINE, PATH_TO_BO_LISTA_PROROGHE } from 'src/app/utils/RoutesConstants'

import { getDefaultAxiosConfig, getFormazioneResourceApi } from 'src/app/utils/ManagerRestGateway'
import GenericBreadCrumb from 'src/frontend/app/components/GenericBreadCrumb'
import { getAllEnti, TIPO_ENTE } from 'src/model/EnteFormazione'
import { TokenStore } from 'src/keycloak/jwt/TokenStore'

const Spacer = () => <br />

let lastRequest: RequestData | null = null

const ListaIscrittiOrdine: React.FC = (props: any) => {
  const myPath = {
    label: 'Concessione proroghe',
    link: PATH_TO_BO_LISTA_ISCRITTI_ORDINE,
  }

  const [enti, setEnti] = useState<any>({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getAllEnti().then(setEnti).catch(console.error)
  }, [])

  const gettableData = async (request: RequestData) => {
    try {
      const { data } = await getFormazioneResourceApi().msfoFormazioneListaIscrittiOrdineFilterableGet(
        generateRequestFilter(request.filters),
        request.pageSize,
        request.currentPage,
        generateRequestSort(request.sortColumn, request.sortDirection),
        getDefaultAxiosConfig(),
      )

      return {
        items: data.items || [],
        total: data.count || 0,
      }
    } catch (e) {
      return { items: [], total: 0 }
    }
  }

  const loadData = async (request: RequestData) => {
    lastRequest = request
    return await gettableData(request)
  }

  const vaiAVisualizzaProroghe = (cf: string) => {
    props.history.push(`${PATH_TO_BO_LISTA_PROROGHE}?cf=${cf}`)
  }

  const filters: any = [
    { label: 'Cognome', field: 'cognome', type: 'input', operator: 'LIKE' },
    { label: 'Nome', field: 'nome', type: 'input', operator: 'LIKE' },
    { label: 'Codice Fiscale', field: 'cf', type: 'input', operator: 'LIKE' },
  ]

  if (TokenStore.getInstance().isCurrentAccountCONAF()) {
    filters.push({
      label: 'Ordine di appartenenza',
      field: 'ordine_territoriale_competente',
      type: 'select',
      options: Object.keys(enti)
        .filter((code) => enti[code].tipo === TIPO_ENTE.ORDINE)
        .map((code) => ({
          label: enti[code].nome,
          value: code,
        })),
    })
  }

  const vaiACreaProroga = (row: any) => {
    props.history.push(PATH_TO_BO_CREA_PROROGA, {
      user: row,
    })
  }

  const renderActions = (row: any) => {
    const hasDeroghe = Array.isArray(row.deroghe) && row.deroghe.length > 0
    return (
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', alignItems: 'center' }}>
        <Button color="primary" size="sm" onClick={() => vaiACreaProroga(row)}>
          Concedi proroga
        </Button>

        {hasDeroghe ? (
          <Button color="primary" size="sm" onClick={() => vaiAVisualizzaProroghe(row.cf)}>
            Visualizza proroghe
          </Button>
        ) : (
          <Button color="secondary" size="sm" disabled>
            Nessuna proroga
          </Button>
        )}
      </div>
    )
  }

  return (
    <PageSection>
      <div className="container register-container">
        <GenericBreadCrumb paths={[myPath]} />

        <Spacer />

        <Title headingLevel="h1" size="lg">
          Concessione proroghe
        </Title>

        <Spacer />

        {loading ? (
          <Spinner />
        ) : (
          <GenericAsyncTableData
            tableKey="lista.assegnazione.cfp"
            emptyMessage="Nessun iscritto trovato"
            filters={filters}
            getRows={loadData}
            columns={[
              { label: 'Cognome', field: 'cognome', isSortable: true },
              { label: 'Nome', field: 'nome', isSortable: true },
              { label: 'Codice Fiscale', field: 'cf', isSortable: true },

              {
                label: '',
                field: 'actions',
                isSortable: false,
                render: renderActions,
              },
            ]}
          />
        )}
      </div>
    </PageSection>
  )
}

export default ListaIscrittiOrdine
